import React from 'react'
import { getBillboardsData as billboardsData } from '../../helpers/strapi.helper';

import close from './../../UI/mobile/sidebar/Icon_Close.svg'

interface Props {
  currentBillboardSelected: string
  currentCompleteCar: string,
  currentCarSelected: string,
  handleSelectBillboard: (payload: string) => void
}

interface State {
  currentSelected: any,
  openBillboard: any
}

class Billboards extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentSelected: {},
      openBillboard: false
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(this.props.currentBillboardSelected !== prevProps.currentBillboardSelected){
        var billboards: any = billboardsData()
        if(this.props.currentBillboardSelected.includes('exterior')){
          var tempBillboardName = this.props.currentBillboardSelected.replace(' exterior','')
          billboards[this.props.currentCompleteCar].exterior.forEach((billboard: any) => {
            if(billboard.title === tempBillboardName){
              this.setState({
                currentSelected: billboard
              }, () => {
                this.setState({
                  openBillboard: true
                })
              })
            }
          })
        }
        if(this.props.currentBillboardSelected.includes('interior')){
          var tempBillboardNameInterior = this.props.currentBillboardSelected.replace(' interior','')
          billboards[this.props.currentCompleteCar].interior.forEach((billboard: any) => {
            if(billboard.title === tempBillboardNameInterior){
              this.setState({
                currentSelected: billboard
              }, () => {
                this.setState({
                  openBillboard: true
                })
              })
            }
          })
        }
      }
  }

  render(): React.ReactNode {
    
      return(
        this.props.currentCompleteCar.split(this.props.currentCarSelected).length > 0 ? 
        <div className={this.state.openBillboard ? 'billboard-container fade-in':'billboard-container fade-out'} onWheel={(e: any) => {e.stopPropagation()}}>
          {this.state.currentSelected ?
            <div className='billboard-general'>
              <div className='close-btn-container' id='element-umbra-analytics' data-type={"BULLET"} data-value={this.props.currentCarSelected} data-second={(this.props.currentCompleteCar.split(this.props.currentCarSelected))[1]} data-child={this.state.currentSelected.title} onClick={() => {
                this.setState({
                  openBillboard: false
                }, () => {
                  setTimeout(() => {
                    this.setState({
                      currentSelected: {}
                    }, () => {this.props.handleSelectBillboard('')})
                  }, 10)//1000
                })
                }}>
                <img id='element-umbra-analytics' data-type={"BULLET"} data-value={this.props.currentCarSelected} data-second={(this.props.currentCompleteCar.split(this.props.currentCarSelected))[1]} data-child={this.state.currentSelected.title} src={close} alt=''/>
              </div>
              <img
                src={this.state.currentSelected.image}
                alt=''
                className='preview-image'
              />
              <div className='billboard-general-title'>
                {this.state.currentSelected.title}
              </div>
              <div className='billboard-general-text'>
                {this.state.currentSelected.text}
              </div>
            </div>:null
          }
        </div>
        : <></>
      )
  }
}

export default Billboards